module.exports = __webpack_public_path__ + "media/images/landing/solutions/solution-1-e78439984f69924fde5afc8257ab3aa2.png";